import { render, staticRenderFns } from "./editHotSearchKeyWord.vue?vue&type=template&id=654a1bf0&scoped=true&"
import script from "./editHotSearchKeyWord.vue?vue&type=script&lang=ts&"
export * from "./editHotSearchKeyWord.vue?vue&type=script&lang=ts&"
import style0 from "./editHotSearchKeyWord.vue?vue&type=style&index=0&id=654a1bf0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654a1bf0",
  null
  
)

export default component.exports